import api from '../../../api/clinique/_examens'

const state = () => ({
    examens: [],
    examens_selected: [],
    examens_selected2: [],
    bonExamen: [],
    demande_examen_consultation: [],
    examen_en_cours: [],

    bon_examens: [],
    facture_examens: [],

    ref_bon_examen: '',
    bons_examen_factures: [],
})

// getters
const getters = {
        examens: (state) => {
            return state.examens
        },

        examens_selected: (state) => {
            return state.examens_selected
        },
        
        bonExamenStored: (state) => {
            return state.bonExamen;
        },

        demande_examen_consultation: (state) => {
            return state.demande_examen_consultation
        },

        examen_en_cours: (state) => {
            return state.examen_en_cours
        },

        bon_examens: (state) => {
            return state.bon_examens
        },

        facture_examens: (state) => {
            return state.facture_examens
        },

        ref_bon_examen: (state) => {
            return state.ref_bon_examen
        },

        bons_examen_factures: (state) => {
            return state.bons_examen_factures;
        },
    }
    // mutations
const mutations = {
    SET_EXAMENS(state, exam) {
        state.examens = exam
    },

    SET_EXAMENS_SELECTED(state, exam) {
        state.examens_selected = exam
    },

    SET_BON_EXAMEN(state, bon) {
        state.bonExamen = bon;
    },

    SET_DEMANDE_EXAMEN_CONSULTATION(state, examen) {
        state.demande_examen_consultation = examen;
    },

    SET_EXAMEN_EN_COURS(state, examen) {
        state.examen_en_cours = examen;
    },

    SET_BON_EXAMENS(state, examen) {
        state.bon_examens = examen;
    },

    SET_FACTURE_EXAMENS(state, facture) {
        state.facture_examens = facture;
    },

    SET_REF_BON_EXAMEN(state, ref) {
        state.ref_bon_examen = ref;
    },

    SET_BONS_EXAMEN_FACTURES(state, bon) {
        state.bons_examen_factures = bon;
    },
}

// actions
const actions = {
    getExamens({ commit }) {
        api.getExamens().then((response) => {
            commit("SET_EXAMENS", response);
        });
    },
    storeBonExamen({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.storeBonExamen(data.idPatient, data).then(
                (response) => {
                    commit("SET_BON_EXAMEN", response);
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },
    getAllExamensForExterne({ commit }) {
        return new Promise((resolve, reject) => {
            api.getAllExamensForExterne().then(
                (response) => {
                    commit("SET_FACTURE_EXAMENS", response);
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    getConsultationExamen({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.getConsultationExamen(data).then(
                response => {
                    commit('SET_DEMANDE_EXAMEN_CONSULTATION', response)
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    updateBulExamen({ dispatch }, data) {
        return new Promise((resolve, reject) => {
            api.updateBulExamen(data).then(
                (response) => {
                    // commit("SET_OPERATION", response);
                    dispatch
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    updateBulExamenDiffere({ dispatch }, data) {
        return new Promise((resolve, reject) => {
            api.updateBulExamenDiffere(data).then(
                (response) => {
                    // commit("SET_OPERATION", response);
                    dispatch
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    getExamenFactureEnCours({ commit }) {
        return new Promise((resolve) => {
            api.getExamenFactureEnCours().then(
                response => {
                    commit('SET_EXAMEN_EN_COURS', response)
                    resolve(response)
                }
            )
        })
    },

    getPrixAssurExamen({ commit }, data) {
        return new Promise((resolve) => {
            api.getPrixAssurExamen(data).then(
                response => {
                    commit('SET_BON_EXAMENS', response)
                    resolve(response)
                }
            )
        })
    },

    getRefBonExamen({ commit }) {
        return new Promise((resolve, reject) => {
            api.getRefBonExamen().then(
                response => {
                    commit("SET_REF_BON_EXAMEN", response);
                    resolve(response);
                }, error => {
                    reject(error)
                }
            )
        })
    },

    savePendingExamen({ dispatch }, data) {
        return new Promise((resolve, reject) => {
            api.savePendingExamen(data).then(
                (response) => {
                    dispatch
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },
};

export default {
    state,
    getters,
    mutations,
    actions
}